module.exports = __webpack_public_path__ + "img/instagram_ikona.6efe81d4.svg";